import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddUserDTO, Users } from 'src/app/core/models/users';
import { MakeUpperPipe } from 'src/app/core/pipes/make-upper.pipe';
import { UserService } from 'src/app/core/services/user.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-bulk-add-user',
  templateUrl: './bulk-add-user.component.html',
  styleUrls: ['./bulk-add-user.component.scss'],
})
export class BulkAddUserComponent implements OnInit {

  fileName: string ;
  importArray: AddUserDTO[] = [];
  @ViewChild('fileUpload') fileUpload;

  constructor(
    public dialog: MatDialogRef<BulkAddUserComponent>,
    private snackBar: MatSnackBar,
    private _userService: UserService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      importType: string,
      requiredParams: string,
      uniqueFields: string
    },
  ) {}

  ngOnInit(): void {}

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    if(this.importArray.length > 0){
      this._userService.addBulkUser(this.importArray).subscribe({
        next: (data: any) => {
          if(data?.message){
            this.snackBar.open(data.message, 'Ok')
          }
        }, error: (err) => {
        }
      });
      this.snackBar.open("Users addition in progress.", 'Ok')
      this.dialog.close();
    }
  }

  onFileSelected(event){
    const file:File = event.target.files[0];
    if(file){
      try {
        this.importArray.length = 0;
        this.fileName = file.name;
        let reader: FileReader = new FileReader();
        reader.readAsText(file);
       
        reader.onload = (e) => {
          let csv: string = reader.result as string;
          csv = csv.trim();
          let csvToRowArray = csv.split("\r\n").filter(e => !e.includes(",,,,,,,,,"));
          let headers = csvToRowArray[0].split(",").map(a => a.toLowerCase());
          let props = Object.getOwnPropertyNames(new AddUserDTO());
          for (let index = 1; index < csvToRowArray.length; index++) {
            let row = csvToRowArray[index].split(",");
            let user = Object.create(AddUserDTO)
            props.forEach((prop, i) => {
              Object.assign(user, { [prop] : row[this.getIndexOfString(prop.toLowerCase(), headers)] })
            });
            this.importArray.push(user)
          }
        }
      } catch (error) {
        this.importArray = [];
        this.snackBar.open("Error reading contents of file.")
      }
    }
  }

  getIndexOfString(value, array: string[]){
    return array.findIndex(a => a.toLowerCase() == value)
  }

  createObj(csvToRowArray: string[]){
    let headers = csvToRowArray[0].split(",");
    let mainObj : Users[] = [];
    for (let i = 1; i < csvToRowArray.length; i++) {
      const element = csvToRowArray[i].split(",");
      const obj: Users = {};
      headers.forEach((head, i) => {
        Object.defineProperty(obj, head, {
          value: element[i],
          writable: true
        })
      });
      mainObj.push(obj);
    }
    return mainObj;
  }

  onFileChange(){
    this.fileUpload.nativeElement.value = "";
  }

  downloadTemplate(){
    // let makeUpper = new MakeUpperPipe();
    // headers.forEach((head, index) => {
      //   headers[index] = makeUpper.transform(head);
      // })
      
    let headers = this.data.requiredParams.split(",");
    const header = headers;
    let csv = ["demo,demo,demo@abc.com,demo1,demo@123,Global Admin/Deployment Admin/Job Operator,demo,123123123"];
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, `ImportUserTemplate.csv`);
  }
}
